import { useCallback, useContext, useEffect, useState } from "react";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import { getArticle } from "./Services/ArticleDiscussionBoardService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import Skeleton from "react-loading-skeleton";

const RecentArticle = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [moreArticleList, setMoreArticleList] = useState([]);
  const [moreArticleDes, setMoreArticleDes] = useState("");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [deleteContent, setDeleteContent] = useState([]);
  const toster = useContext(TostMsg);
  const defaultImage = "/images/default-award-Image.svg";
  let history = useHistory();
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    GetMoreArticleList();
    GetMasterSystemAlertList();
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "Articl_Details_show_more") {
        setMoreArticleDes(msg?.Desc);
      } else if (msg?.Name == message) {
        setDeleteContent(msg?.Desc);
      }
    });
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function GetMoreArticleList() {
    setShowLoader(true);
    const params = {
      LoggedInUserId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
      articleByGUID: "",
      articleId: 0,
      Search: "",
      articleById: 0,
      IsFeatured: 0,
      IsArchived: 0,
      PageNumber: 1,
      PageSize: 3,
    };
    try {
      const response = await getArticle(params);
      setShowLoader(false);
      setMoreArticleList(response.Data?.orgArticles);
    } catch (error) {
      setShowLoader(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const clickToCurrentArticle = (article) => {
    const Archived = article?.IsArchived == false ? 0 : 1;
    history.push(`/Article/Detail/${article?.GUID}/${Archived}`);
  };

  //   const truncatedSummary = (article) => {
  //     debugger
  //     return article?.Summary?.length >= 60
  //       ? `${article.Summary.substring(0, 60)}...`
  //       : article?.Summary;
  //   };

  const truncatedSummary = (article) => {
    if (!article?.Summary) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = article.Summary;
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    const truncated =
      plainText.length > 40 ? `${plainText.substring(0, 40)}...` : plainText;
    return truncated;
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="shortlisted">
              <strong className="upcome">{moreArticleDes}</strong>
              {showLoader ? (
                <Skeleton height={100} width="100%" />
              ) : (
                <div className="article-list mt-3">
                  {moreArticleList?.map((article, index) => (
                    <div
                      onClick={() => clickToCurrentArticle(article)}
                      className="list"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={article?.ArticleMedia[0]?.Media || defaultImage}
                        onError={handleImageError}
                      />
                      <div className="px-2">
                        <h4>{article?.Title}</h4>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: truncatedSummary(article),
                          }}
                        ></p>
                        <div className="article-list-actions">
                          <div className="d-flex align-items-center">
                            <div className="image">
                              <LazyImage
                                src={article?.ArticleByProfileImage}
                                width="100%"
                              />
                            </div>
                            <p className="writtenby">
                              <span>Written by</span>
                              {article?.ArticleByName.substring(0, 40)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RecentArticle;
